import React from "react";
import { Link } from "react-router-dom";
import Button from "../Button/Button";

import EditIcon from "./images/edit.svg";
import PauseIcon from "./images/pause.svg";
import StartIcon from "./images/start.svg";
import ReloadIcon from "./images/restart.svg";
import StatIcon from "./images/stat.svg";
import HistoryIcon from "./images/history.svg";
import SearchIcon from "./images/search.svg";

import CpcButton from "./CpcButton";

import { teaserStatus, campaignTypes } from "../../constants";

import * as urls from "../../utils/urls.js";

import IfPermission from "../../components/IfPermission";
import * as perm from "../../utils/perm";

import usePermissions from "../../hooks/usePermissions";

const MainTeaserButtons = ({
  teaser,
  onStatusClick,
  onReloadClick,
  onCpcChange,
  cpcError,
  cpcMode,
  onCpcModeChange
}) => {
  let nextStatus;
  let statusIcon;

  if (teaser.published == teaserStatus.active) {
    nextStatus = teaserStatus.inactive;
    statusIcon = PauseIcon;
  } else if (teaser.published == teaserStatus.inactive) {
    nextStatus = teaserStatus.active;
    statusIcon = StartIcon;
  }

  const handleStatusChange = () => {
    onStatusClick(nextStatus);
  };

  const canRestart = (permissions, user) => {
    return (
      perm.canRestartAll(permissions) ||
      (perm.canRestart(permissions) && (teaser.user || {}).id == user.id)
    );
  };

  const canStartStop = (permissions, user) => {
    return (
      perm.canStartStopAll(permissions) ||
      (perm.canStartStop(permissions) && (teaser.user || {}).id == user.id)
    );
  };

  const canEdit = (permissions, user) => {
    if (teaser.payout_done && !perm.canEditAfterPay(permissions)) {
      return false;
    }

    const teaserUser = teaser.user || {};

    return teaserUser.id == user.id || perm.canEditAllTeasers(permissions);
  };

  const permissions = usePermissions();

  return (
    <React.Fragment>
      <IfPermission checker={canEdit}>
        <Link
          to={{ pathname: urls.teaserEdit(teaser.id), state: { modal: true } }}
        >
          <Button icon={EditIcon} color="light-blue" />
        </Link>
      </IfPermission>

      <IfPermission checker={canStartStop}>
        {(teaser.published == teaserStatus.active ||
          teaser.published == teaserStatus.inactive) && (
          <Button
            icon={statusIcon}
            color="light-blue"
            onClick={handleStatusChange}
          />
        )}
      </IfPermission>

      <IfPermission checker={canRestart}>
        <Button
          icon={ReloadIcon}
          color="light-blue"
          onClick={onReloadClick}
          disabled={teaser.should_reset_stat}
        />
      </IfPermission>

      <IfPermission checker={perm.canViewStat}>
        <Link
          to={{ pathname: urls.teaserStat(teaser.id), state: { modal: true } }}
        >
          <Button icon={StatIcon} color="light-blue" />
        </Link>
      </IfPermission>

      <IfPermission checker={perm.canViewHistory}>
        <Link
          to={urls.teaserLog(teaser.id)}
          target="blank"
          className="link-button"
        >
          <Button icon={HistoryIcon} color="light-blue" />
        </Link>
      </IfPermission>

      <Link
        to={{
          pathname: urls.teaserList(),
          search: `?teasers_search_term=${teaser.title}`
        }}
        title={"Поиск дублей"}
        target={"_blank"}
      >
        <Button icon={SearchIcon} color="light-blue" />
      </Link>

      <IfPermission checker={perm.canViewCpc}>
        {teaser.campaign.type == campaignTypes.ad && (
          <CpcButton
            value={teaser.cpc}
            onChange={onCpcChange}
            error={cpcError}
            mode={cpcMode}
            onModeChange={onCpcModeChange}
            readonly={!perm.canChangeCpc(permissions)}
          />
        )}
      </IfPermission>
    </React.Fragment>
  );
};

export default MainTeaserButtons;
